export enum SurveyRespondentConflictType {
  email = 'email address',
  mobileNumber = 'mobile number',
  name = 'name',
}
